const IS_MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
const ALTTEXT = IS_MAC
    ? 'Option'
    : 'Alt';
const CTRLTEXT = 'CTRL';
const DISALLOWEDKEYS = [
    'Shift',
    'Control',
    'ControlLeft',
    'ControlRight',
    'Alt',
    'AltLeft',
    'AltRight'
];
const HOTKEYEVENTS = [
    {
        name: 'Overlay',
        keys: ['KeyH'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + H`,
        description: '',
        path: '',
        securityLevelRequired: ['Administrator', 'Ecommerce Management', 'Payment Management', 'Payments Administrator']
    },
    {
        name: 'Products',
        keys: ['KeyP'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + P`,
        description: 'Go to the Item Search page',
        path: '/products',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    },
    {
        name: 'Search',
        keys: ['KeyS'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + S`,
        description: 'Look-up an Item by Code, Barcode or Name',
        path: '',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    },
    {
        name: 'Navigation',
        keys: ['KeyM'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + M`,
        description: 'Open the navigation menu',
        path: '',
        securityLevelRequired: ['Administrator', 'Ecommerce Management', 'Payment Management', 'Payments Administrator']
    },
    {
        name: 'Wizards',
        keys: ['KeyW'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + W`,
        description: 'Go to the Bulk Wizards page',
        path: '/wizards',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    },
    {
        name: 'Orders',
        keys: ['KeyO'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + O`,
        description: 'Go to the Order Dashboard',
        path: '/orders',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    },
    {
        name: 'Filter',
        keys: ['KeyQ'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + Q`,
        description: 'Go to the Filter Quick Apply page',
        path: '/item-filter-quick-apply',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    },
    {
        name: 'Banners',
        keys: ['KeyB'],
        alt: true,
        ctrl: false,
        keyString: `${ALTTEXT} + B`,
        description: 'Go to the Banner Management page',
        path: '/banners',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    },
    {
        name: 'Save',
        keys: ['KeyS'],
        alt: false,
        ctrl: true,
        keyString: `${CTRLTEXT} + S`,
        description: 'To save changes (on pages with editable data)',
        path: '',
        securityLevelRequired: ['Administrator', 'Ecommerce Management']
    }
];
const PRIVATEHOTKEYEVENTS = [
    {
        name: 'Close',
        keys: ['Escape'],
        alt: false,
        ctrl: false,
        description: 'Closes hotkey modals',
        path: '',
        securityLevelRequired: ['Administrator', 'Ecommerce Management', 'Payment Management', 'Payments Administrator']
    }
];
let pressedKeys = [];
let altPressed = false;
let ctrlPressed = false;

function handleKeyPress(event) {
    const pressedKey = event.code;
    let returnValue = false;

    altPressed = event.altKey;
    ctrlPressed = event.ctrlKey;

    if ((altPressed || ctrlPressed || pressedKey === 'Escape') && !(altPressed && ctrlPressed)) {
        if (!pressedKeys.includes(pressedKey) && !DISALLOWEDKEYS.includes(pressedKey)) {
            returnValue = true;
            pressedKeys.push(pressedKey);
        }

        const currentHotkey = checkKeyPress();
        if (currentHotkey && currentHotkey.name == 'Save') {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    return returnValue;
}

function handleKeyRelease(event) {
    altPressed = event.altKey;
    ctrlPressed = event.ctrlKey;

    pressedKeys = pressedKeys.filter(k => k != event.code);
}

function checkKeyPress() {
    let foundEvent = null;

    // Only support single key hotkeys currently
    if (pressedKeys.length == 1) {
        foundEvent = HOTKEYEVENTS.find(h => h.keys[0] == pressedKeys[0] && h.alt == altPressed && h.ctrl == ctrlPressed);
    }

    if (pressedKeys.length == 1 && !foundEvent) {
        foundEvent = PRIVATEHOTKEYEVENTS.find(h => h.keys[0] == pressedKeys[0] && h.alt == altPressed && h.ctrl == ctrlPressed);
    }

    return foundEvent;
}

export default {
    HOTKEYEVENTS,
    pressedKeys,
    handleKeyPress,
    handleKeyRelease,
    checkKeyPress,
    ALTTEXT
};
